var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import NonLabExamImageCardAPI from './non-lab-exam-image-card-api';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import moment from 'moment';
import image from '../../../../health-professional/resources/assets/avatar_image.svg';
import './non-lab-exam-image-card.css';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let NonLabExamImageCard = class NonLabExamImageCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { dsImagem, dsArquivoImagem, dtAtualizacao, onClick, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dsArquivoImagem,
                        dsImagem,
                        dtAtualizacao,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    splitFileName(path) {
        if (!path) {
            return MessageService.translate('text.file-not-found');
        }
        const separator = '?';
        const name = path.split(separator);
        return name[name.length - 1];
    }
    getTitle(dsImagem, fileName) {
        if (dsImagem) {
            return dsImagem;
        }
        const title = fileName.charAt(0).toUpperCase() + fileName.slice(1);
        return title;
    }
    renderContent() {
        const { dsImagem, dsArquivoImagem, dtAtualizacao } = this.props;
        const fileName = this.splitFileName(dsArquivoImagem);
        const title = this.getTitle(dsImagem, fileName);
        const formattedDtAtualizacao = moment(String(dtAtualizacao)).format('L LT');
        const subtitle = `${fileName} - ${MessageService.translate('label.clinical-notes-viewer.clinical-note-date')} ${formattedDtAtualizacao}`;
        return (React.createElement("div", { className: "c-non-lab-exam-image-card__wrapper" },
            React.createElement(Avatar, { title: title, subtitle: subtitle, image: image, showImageBorder: true })));
    }
    render() {
        const { dsArquivoImagem, dsImagem } = this.props;
        return (React.createElement(Card, { selectionType: SelectionType.SINGLE, width: 12, onClick: this.handleClick, uuid: generateUUID(), key: `${dsArquivoImagem} + ${dsImagem}` },
            React.createElement(React.Fragment, null, this.renderContent())));
    }
};
NonLabExamImageCard = __decorate([
    AwesomeComponent({ api: NonLabExamImageCardAPI, type: ComponentType.DATA_DISPLAY })
], NonLabExamImageCard);
export default NonLabExamImageCard;
//# sourceMappingURL=non-lab-exam-image-card.js.map